import { Image } from 'react-native'
import Svg, { Text as SvgText } from 'react-native-svg'
import { fonts } from '../lib/theme'

// Medaglia al collo dell'avatar (oro, argento, bronzo): immagine disegnata (assets/person/medal_*.png, estratta
// dalla versione generata con Gemini, stessa area 512x512 dei livelli) con il numero della posizione sopra,
// scritto qui col carattere del brand. Vale per uomo e donna: il colletto sta nella stessa posizione.
const MEDALS = {
  gold:   { src: require('../assets/person/medal_gold.png'),   num: '1', ink: '#7A5A06' },
  silver: { src: require('../assets/person/medal_silver.png'), num: '2', ink: '#4B5563' },
  bronze: { src: require('../assets/person/medal_bronze.png'), num: '3', ink: '#5E3410' },
}
const CX = 256, CY = 431   // centro della medaglia nel sistema 512x512

export default function PersonAvatarMedal({ kind = 'gold', size }) {
  const m = MEDALS[kind] ?? MEDALS.gold
  const layer = { position: 'absolute', top: 0, left: 0, width: size, height: size }
  return (
    <>
      <Image source={m.src} style={layer} resizeMode="contain" fadeDuration={0} />
      <Svg width={size} height={size} viewBox="0 0 512 512" style={layer} pointerEvents="none">
        <SvgText x={CX} y={CY + 13} textAnchor="middle" fontFamily={fonts.condensedBold} fontSize={38} fill={m.ink}>{m.num}</SvgText>
      </Svg>
    </>
  )
}
